export default {
    Content1: "Chia sẻ kiển thức, kinh nghiệm và “thâm cung bí sử” trong nghề kiểm thử, hỗ trợ tư vấn, định hướng nghề nghiệp đống thời cung cấp các khoá học cho kiểm thử Mobile, Website, API và hiệu năng bởi các chuyên gia có nhiều năm kinh nghiệm.",
    Content2: "Website: https://testek.vn",
    Content3: "Hotline (Zalo): 0946210891",
    Content4: "Các khoá học được Testek cung cấp:",
    Content5: "Tại Testek:",
    Content6: "Giảng viên là các chuyên gia đầu ngành",
    Content7: "Học để làm KHÔNG học để biết",
    Content8: "Định hướng nghề nghiệp",
    Content9 : "Học liệu tại Testek:",
    Content10 : "API System:",
    Title1 : 'TESTEK - KIỂM THỬ THỰC CHIẾN',
    Title2 : 'Đào tạo API Testing, Performance Testing, Automation Testing',
    Title3: 'Các hệ thống Testek cung cấp',
    Title4: 'HỆ THỐNG THỰC HÀNH CƠ BẢN TRONG AUTOMATION TESTING, CÙNG CHUNG TAY XÂY DỰNG CỘNG ĐỒNG KIỂM THỬ TỰ ĐỘNG VIỆT NAM LỚN MẠNH!!!',
    NoteBank : 'Nếu bạn thấy có ích hãy cùng mình duy trì page này nhé (5k, 10k là quý lắm ạ)' 
}